/* Native disclosure + progressive hover enhancement. Reconnects after AJAX filters. */
if (!customElements.get('vv-card-siblings')) {
  customElements.define('vv-card-siblings', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.card = this.closest('product-card');
      if (!this.details || !this.summary || !this.card) return;
      this.pinned = false;
      this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.card.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && this.hoverQuery.matches) this.reveal();
      }, options);
      this.card.addEventListener('pointerleave', () => {
        if (!this.pinned && !this.contains(document.activeElement)) this.close();
      }, options);
      this.summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.details.open) this.close();
        else { this.pinned = true; this.reveal(); }
      }, options);
      this.card.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.close();
          this.summary.focus();
        }
      }, options);
      this.addEventListener('focusout', (event) => {
        if (!this.pinned && !this.contains(event.relatedTarget) && !this.card.matches(':hover')) this.close();
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (this.details.open && !this.card.contains(event.target)) this.close();
      }, options);
    }
    reveal() {
      const previous = this.constructor.active;
      if (previous && previous !== this) previous.close();
      this.details.open = true;
      this.constructor.active = this;
    }
    close() {
      this.details.open = false;
      this.pinned = false;
      if (this.constructor.active === this) this.constructor.active = null;
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.constructor.active === this) this.constructor.active = null;
    }
  });
}
